export const setPreferences = (preferences?: any) => {
  localStorage.setItem('captionPreferences', JSON.stringify(preferences));
};

export const getPreferences = () => {
	const getPreferencesFromLocalStorage = localStorage.getItem('captionPreferences') as string
  return JSON.parse(getPreferencesFromLocalStorage);
};

